export const SYS_ADMIN = 'SYS_ADMIN';
export const COMPANY_ADMIN = 'COMPANY_ADMIN';
export const USER = 'USER';
export const REGULATOR = 'REGULATOR';
export const REGULATOR_ADMIN = 'REGULATOR_ADMIN';
export const ANONYMOUS = 'ANONYMOUS';



// WEBPACK FOOTER //
// ./config/permissions/roles.js